import { GeoPosition } from '../config/general.config.js';
import { ModelBase } from './_model.base.js';

export class Location {
	public name: string;
	public locationStatuses: string[];
	public city: string;
	public isNorthAmerican: boolean;
	public aggregateName?: string;
	public geoPosition?: GeoPosition;
	public excludeFromMap?: boolean;
	public sortOrder?: number;
	public firstInGeoTooltip?: boolean;

	public constructor(city: string = '', locationStatuses: string[] = []) {
		this.name = this.city = city;
		this.locationStatuses = locationStatuses;
	}
}

export class DataHubLocation extends ModelBase {
	public modelId: string;
	public location: string;
	public locationStatus: string;
}
